import React, { useState } from "react";
import { Calendar as CalendarIcon } from "lucide-react";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";

export const CalendarButton = ({ events }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Button
        data-testid="calendar-btn"
        variant="outline"
        size="sm"
        onClick={() => setIsOpen(true)}
        className="flex items-center gap-2 border-white/10 hover:bg-white/5"
      >
        <CalendarIcon className="w-4 h-4" />
        <span className="hidden sm:inline">Calendrier</span>
      </Button>

      <Dialog open={isOpen} onOpenChange={setIsOpen}>
        <DialogContent className="max-w-3xl max-h-[80vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="text-2xl text-street tracking-wide flex items-center gap-2">
              <CalendarIcon className="w-6 h-6 text-primary" />
              Calendrier des événements
            </DialogTitle>
          </DialogHeader>

          <div className="mt-6 space-y-3">
            {events.length === 0 ? (
              <div className="text-center py-12 text-muted-foreground">
                Aucun événement programmé
              </div>
            ) : (
              <div className="space-y-3">
                {events.map((event) => {
                  const dayMatch = event.date.match(/\d+/);
                  const day = dayMatch ? dayMatch[0] : "?";
                  const monthMatch = event.date.match(/(\w+)/);
                  const month = monthMatch ? monthMatch[1].substring(0, 3) : "";

                  return (
                    <div
                      key={event.id}
                      className="glass-card rounded-lg p-4 flex items-start gap-4 hover:bg-white/5 transition-colors"
                    >
                      <div className="flex-shrink-0 w-16 text-center">
                        <div className="bg-primary/10 rounded-lg p-2 border border-primary/20">
                          <div className="text-2xl font-bold text-primary">{day}</div>
                          <div className="text-xs text-muted-foreground uppercase">{month}</div>
                        </div>
                      </div>

                      <div className="flex-1 min-w-0">
                        <h4 className="font-semibold mb-1 truncate">{event.title}</h4>
                        <p className="text-sm text-muted-foreground mb-1">{event.artist}</p>
                        <div className="flex flex-wrap items-center gap-3 text-xs text-muted-foreground">
                          <span>{event.time}</span>
                          <span>•</span>
                          <span>{event.venue}</span>
                        </div>
                      </div>

                      <div className="flex-shrink-0 text-right">
                        <div className="text-lg font-bold text-primary">{event.price}€</div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
